import mq from 'shared/mq';

export default class Sidebar {
  constructor() {
    const _this = this;

    mq.register('large', {
      match() {
        _this.init();
      },
      unmatch() {
        _this.destroy();
      },
    });
  }

  init() {
    console.info('Sidebar:init');
  }

  destroy() {
    console.info('Sidebar:destroy');
  }
}

/*
import $ from 'shared/$';
const Mq = require('shared/mq');
const ResizeSensor = require('css-element-queries/src/ResizeSensor');

export class Sticky {
  constructor() {
    const _this = this;
    this.offset = 50;
    this.nav = document.querySelector('.guide-nav__list-outer');
    this.content = document.querySelector('.travel-guide__content-outer');

    Mq.register('medium-l', {
      match: function() {
        _this.init();
      },
      unmatch: function() {
        _this.destroy();
      },
    });
  }

  init() {
    // console.info('Sticky:init');
    this.onResize = this.resize.bind(this);
    this.onScroll = this.scroll.bind(this);
    this.check();
    this.bind();
  }

  bind() {
    window.addEventListener('resize', this.onResize);
    window.addEventListener('scroll', this.onScroll);
    this.sensor = new ResizeSensor(
      this.nav,
      this.check.bind(this)
    );
  }

  unbind() {
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('scroll', this.onScroll);
  }

  resize() {
    this.check();
  }

  scroll() {
    this.do();
  }

  check() {
    this.topLimit = $.offset(this.content).top;
    this.navWidth = this.nav.offsetWidth;
    this.bottomLimit = this.topLimit + this.content.offsetHeight - this.nav.offsetHeight;
    this.do();
  }

  do() {
    const scrollY = document.body.scrollTop + this.offset;
    if (scrollY < this.topLimit) {
      this.clear();
      TweenLite.set(this.nav, { y: 0 });
    } else if (scrollY >= this.topLimit && scrollY <= this.bottomLimit) {
      // TweenLite.set(this.nav, { y: scrollY - this.topLimit });
      this.nav.style.width = this.navWidth + 'px';
      this.nav.style.position = 'fixed';
      this.nav.style.top = this.offset + 'px';
      TweenLite.set(this.nav, { y: 0 });
    } else {
      this.clear();
      TweenLite.set(this.nav, { y: this.bottomLimit - this.topLimit });
    }
  }

  clear() {
    this.nav.style.position = 'relative';
    this.nav.style.top = 'auto';
    this.nav.style.width = 'auto';
  }

  destroy() {
    // console.info('Sticky:destroy');
    this.unbind();
    this.sensor.detach();
    TweenLite.set(this.nav, { y: 0 });
  }
}
*/
